module.exports = __webpack_public_path__ + "img/job-offer.798f782a.svg";